module.exports = __webpack_public_path__ + "static/media/ibu-12.a368a163.png";